import * as React from 'react';
import { observer } from 'mobx-react';
import * as classNames from 'classnames';
import { IItemInventory } from '../../../../../common/interfaces/search';
import { IStockDetailsView } from '../../../../../common/interfaces/stock';
import { LoadingSpinner } from '../../../components/indicator';
import { Tooltip } from '../../../components/popup';

// Styles
const s = require('./PortalSearchItem.css');
const stockInformation = require('./../../../assets/information-icon.svg');

// Props
interface IPortalSearchItemInventoryPacProps {
    onRegionalStockDetailsShow: () => void;
    onRegionalStockDetailsHide: () => void;
    regionalStockDetails: IStockDetailsView | null;
    inventory: IItemInventory[];
    itemcode: string;
}

// Component
@observer
export class PortalSearchItemInventoryPac extends React.Component<IPortalSearchItemInventoryPacProps, {}> {
    static get defaultProps(): IPortalSearchItemInventoryPacProps {
        return {
            onRegionalStockDetailsShow: null,
            onRegionalStockDetailsHide: null,
            regionalStockDetails: null,
            inventory: [],
            itemcode: ''
        };
    }

    public render() {
        return (
            <div className={classNames(s.inventory, s.inventoryInline)}>
                {this.props.inventory.map((stock) => {
                    return (
                        <p key={stock.code} className={s.inlineStock}>
                            <span>{stock.code}</span>

                            {stock.numberCount > 0 && stock.code === 'Regional' && (
                                <button onClick={this.handleStockDetailsShow} className={s.stockDetails} title="Details">
                                    <img src={stockInformation} alt="" />
                                </button>
                            )}

                            <strong
                                className={classNames({
                                    [s.available]: stock.numberCount > 0
                                })}
                            >
                                {stock.count}
                            </strong>
                        </p>
                    );
                })}

                <Tooltip
                    className={s.stockDetailsTooltip}
                    onClose={this.handleStockDetailsHide}
                    title={`Regional stock for item ${this.props.itemcode}`}
                    show={this.props.regionalStockDetails !== null}
                >
                    {this.props.regionalStockDetails !== null && (
                        <div className={s.stockDetailsTooltipContent}>
                            {(this.props.regionalStockDetails.loading === true && (
                                <div className={s.loading}>
                                    <LoadingSpinner active={true} size={24} />
                                    <p>Getting stock details...</p>
                                </div>
                            )) || (
                                <table className={s.stockDetailsTooltipTable}>
                                    <thead>
                                        <tr>
                                            <td>Location</td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.regionalStockDetails.warehouses.map((warehouse) => {
                                            return (
                                                <tr key={warehouse.whsCode}>
                                                    <td>{warehouse.whsName}</td>
                                                    <td
                                                        className={classNames({
                                                            [s.available]: warehouse.available
                                                        })}
                                                    >
                                                        {warehouse.available ? 'In stock' : 'Out of stock'}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    )}
                </Tooltip>
            </div>
        );
    }

    private handleStockDetailsShow = () => {
        this.props.onRegionalStockDetailsShow();
    };

    private handleStockDetailsHide = () => {
        this.props.onRegionalStockDetailsHide();
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalSearch/PortalSearchItemInventoryPac.tsx